import React from 'react'
import CIcon from '@coreui/icons-react'
import {
    cilSpeedometer,
    cilStorage,
} from '@coreui/icons'
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react'

const _nav = [
    {
        component: CNavGroup,
        name: 'registers',
        to: '/',
        icon: <CIcon icon={cilStorage} customClassName="nav-icon" />,
        items: [
            
            {
                component: CNavItem,
                name: 'products',
                to: '/products',
            },
            {
                component: CNavItem,
                name: 'client_category',
                to: '/client_category',
            },
            {
                component: CNavItem,
                name: 'users',
                to: '/users',
            },
        ],
    },

]

export default _nav
